const inputLabels = {
  en: {
    translation: {
      name: "Name",
      nameInternational: "International name",
      alias: "Alias",
      email: "Email",
      prefix: "Prefix",
      number: "Number",
      formattedAddress: "Address",
      route: "Address",
      streetNumber: "Street number",
      postalCode: "Postal code",
      addressDetails: "Details",
      country: "Country",
      admin1: "State/Region",
      admin2: "Province",
      admin3: "City/Town",
      city: "District",
      priceMinimum: "Price minimum",
      priceMaximum: "Price maximum",
      foodType: "Insert a type of food",
      home_products: "Home made product",
      best_products: "Special dish",
      km0_products: "Farm-to-table product",
      description: "Description",
      date: "Date",
      date_start: "Start date",
      date_end: "End date",
      defaultDescription: "Description",
      language_description: "Additional language",
      slogan: "Short description",
      public_transport: "Public transport",
      pinterestLinks: "Pinterest link",
      twitterLinks: "Twitter link",
      instagramLinks: "Instagram link",
      linkedinLinks: "Linkedin link",
      googlePlusLinks: "Google Card link",
      facebookLinks: "Facebook link",
      webLinks: "Weblink",
      tags: "Insert here your tags",
      legalAddress: "Legal address",
      legalAddressCorporation: "Indirizzo sede legale",
      legalAddressSoleProprietorship: "Indirizzo sede attività",
      coordinatedBy: "Società soggetta alla direzione e coordinamento da",
      vatId: "Vat ID",
      fiscalCode: "Fiscal Code",
      rea: "Register office and REA number",
      pec: "Certified e-mail",
      businessName: "Business name",
      businessNameCorporation: "Business name",
      businessNameSoleProprietorship: "Business name",
      businessNamePhysicalPerson: "First name and last name",
      liquidation: "Liquidation",
      shareCapital: "Share capital",
      ownerName: "Owner name",
      login_email: "Email address",
      login_password: "Password",
      firstName: "First name",
      middleName: "Middle name",
      lastName: "Last name",
      gender: "Gender",
      username: "Username",
      birthDate: "Birth date",
      locality: "City",
      favouriteCuisine: "Category",
      idealCompany: "Ideal for",
      favouritePlate: "Food type"
    }
  },
  it: {
    translation: {
      name: "Nome",
      nameInternational: "Nome internazionale",
      alias: "Alias",
      email: "Email",
      prefix: "Prefisso",
      number: "Numero",
      formattedAddress: "Indirizzo",
      route: "Via",
      streetNumber: "Numero civico",
      postalCode: "CAP",
      addressDetails: "Dettagli",
      country: "Nazione",
      admin1: "Stato/Regione",
      admin2: "Provincia",
      admin3: "Città/Paese",
      city: "Quartiere",
      priceMinimum: "Prezzo minimo",
      priceMaximum: "Prezzo massimo",
      foodType: "Inserisci un tipo di cucina",
      home_products: "Prodotti della casa",
      best_products: "Specialità",
      km0_products: "Prodotti a km0",
      description: "Descrizione",
      date: "Data",
      date_start: "Data inizio",
      date_end: "Data fine",
      defaultDescription: "Descrizione",
      language_description: "Descrizione in lingua",
      slogan: "Descrizione breve",
      public_transport: "Trasporti pubblici",
      pinterestLinks: "Link Pinterest",
      twitterLinks: "Link Twitter",
      instagramLinks: "Link Instagram",
      linkedinLinks: "Link Linkedin",
      googlePlusLinks: "Link Google Card",
      facebookLinks: "Link Facebook",
      webLinks: "Weblink",
      tags: "Inserisci qui i tuoi tag",
      legalAddress: "Indirizzo legale",
      legalAddressCorporation: "Indirizzo sede legale",
      legalAddressSoleProprietorship: "Indirizzo sede attività",
      coordinatedBy: "Società soggetta alla direzione e coordinamento dalla",
      vatId: "Partita IVA",
      fiscalCode: "Codice fiscale",
      rea: "Ufficio del registro e numero REA",
      pec: "Posta elettronica certificata",
      businessName: "Nome società",
      businessNameCorporation: "Ragione sociale",
      businessNameSoleProprietorship: "Nome attività",
      businessNamePhysicalPerson: "Nome e cognome",
      liquidation: "Liquidazione",
      shareCapital: "Capitale sociale",
      ownerName: "Nome proprietario",
      login_email: "Indirizzo email",
      login_password: "Password",
      firstName: "Nome",
      middleName: "Secondo nome",
      lastName: "Cognome",
      gender: "Sesso",
      username: "Username",
      birthDate: "Data di nascita",
      locality: "Città",
      favouriteCuisine: "Categoria",
      idealCompany: "Ideale per",
      favouritePlate: "Tipo di cucina"
    }
  }
};

export default inputLabels;
